import React from "react";
import { Navigate } from "react-router-dom";


export default function PublicWrapper({ children }) {
    const authUser = localStorage.getItem('authTokens')

    return authUser ? <Navigate to='/' /> : children
}
